import React from 'react';
import PropTypes from 'prop-types';
import { Collapse, Button, Popconfirm } from 'antd';

import { IconDelete } from '../../../data/assets/icons';

import ErrorBoundary from '../../errorboundary';
import SelectWorkflowForm from '../selectworkflowform';
import ResetParameterForm from '../resetparameterform';
import SelectArrayItem from '../selectarrayitem';

const Panel = Collapse.Panel;

const ResetWorkflowsForm = (props) => {
    const { reset_workflows, workflows, variables, actions, messages, card_container_class, title, title_class, container_class, workflow_container, workflow_title, workflow_title_class, workflow_select_class, workflow_placeholder, onChangeWorkflow, node_container, node_title, node_title_class, node_select_class, node_visit_title, node_placeholder, onChangeNode, onChangeNodeVisit, onClickAddResetWorkflows, reset_parameter_title, onChangeParameterKey, onChangeParameterValue, onClickDeleteResetParameterItem, onClickAddResetParameter, message_before_title, message_before_placeholder, onClickDeleteMessageBeforeItem, onClickAddMessageBeforeItem, criteria_title, onChangeContextVariableKey, onChangeContextVariableValue, onClickDeleteContextVariable, context_variable_value_title, context_variable_value_placeholder, onClickAddContextVariable, onClickAddContextVariablesValueExist, current_workflow_title, current_workflow_placeholder, onClickDeleteContextVariablesValueExist, onChangeCurrentWorkflow, onClickDeleteResetWorkflowsItem } = props;

    return (
        <div className={container_class}>
            {
                title &&
                <p className={`ori-capitalize-first ${title_class}`}>{title}</p>
            }
            <Collapse className="ori-collapse-card ori-collapse-card-default ori-collapse-card-shadow-none" >
                {
                    reset_workflows && reset_workflows.map((item, index) => {
                        return (
                            <Panel header={
                                <div className="ori-flex-row ori-flex-jsb">
                                    <div>
                                        <span>{`Workflow ${index}`}</span>
                                    </div>
                                    <Popconfirm title="Are you sure？" placement="topRight" okText="Yes" cancelText="No" onConfirm={() => onClickDeleteResetWorkflowsItem(index)}>
                                        <div className="ori-lr-pad-5">
                                            <IconDelete size={16} className="ori-font-light-hover-primary ori-cursor-ptr" />
                                        </div>
                                    </Popconfirm>
                                </div>
                            } key={index} showArrow={false}>
                                <div className={card_container_class}>
                                    {
                                        item && item.resetWorkflow &&
                                        <ErrorBoundary>
                                            <SelectWorkflowForm container_class="ori-b-mrgn-10" workflow_container={workflow_container} workflow_title={workflow_title} workflow_title_class={workflow_title_class} workflow_select_class={workflow_select_class} workflow_placeholder={workflow_placeholder} node_container={node_container} node_title={node_title} node_title_class={node_title_class} node_select_class={node_select_class} node_placeholder={node_placeholder} workflows={workflows} wid={item.resetWorkflow.wid} nodeId={item.resetWorkflow.nodeId} show_node_visit node_visit_title={node_visit_title} node_visit={item.resetWorkflow.nodeVisit} onChangeWorkflow={(wid) => onChangeWorkflow(wid, index)} onChangeNode={(nodeId) => onChangeNode(nodeId, index)} onChangeNodeVisit={(nodeVisit) => onChangeNodeVisit(nodeVisit, index)} />
                                        </ErrorBoundary>
                                    }
                                    {
                                        item && item.resetParameters &&
                                        <ErrorBoundary>
                                            <ResetParameterForm title={reset_parameter_title} variables={variables} reset_parameters={item.resetParameters} onChangeParameterKey={(key, parameter_index) => onChangeParameterKey(key, index, parameter_index)} onChangeParameterValue={(value, parameter_index) => onChangeParameterValue(value, index, parameter_index)} onClickDeleteResetParameterItem={(parameter_index) => onClickDeleteResetParameterItem(index, parameter_index)} onClickAddResetParameter={() => onClickAddResetParameter({ key: undefined, value: "" }, index)} />
                                        </ErrorBoundary>
                                    }
                                    {
                                        item && item.criteria &&
                                        <ErrorBoundary>
                                            <div className="ori-b-pad-5">
                                                {
                                                    criteria_title &&
                                                    <p className="ori-b-mrgn-5 ori-capitalize-first">{criteria_title}</p>
                                                }
                                                <ErrorBoundary>
                                                    <SelectWorkflowForm hide_node container_class="ori-b-mrgn-10" workflow_title={current_workflow_title} workflow_placeholder={current_workflow_placeholder} workflows={workflows} wid={item.criteria.current_wid} onChangeWorkflow={(wid) => onChangeCurrentWorkflow(wid, index)} />
                                                </ErrorBoundary>
                                                <ErrorBoundary>
                                                    <ResetParameterForm title="context variables" add_button_text="Add Context Variable" variables={actions} reset_parameters={item.criteria.contextVariables} onChangeParameterKey={(key, cv_index) => onChangeContextVariableKey(key, index, cv_index)} onChangeParameterValue={(value, cv_index) => onChangeContextVariableValue(value, index, cv_index)} onClickDeleteResetParameterItem={(cv_index) => onClickDeleteContextVariable(index, cv_index)} onClickAddResetParameter={() => { onClickAddContextVariable({ key: undefined, value: "" }, index) }} />
                                                </ErrorBoundary>
                                                <ErrorBoundary>
                                                    <SelectArrayItem type="string" add_btn_text="add context variable value" title={context_variable_value_title} select_placeholder={context_variable_value_placeholder} options={variables} array={item.criteria.contextVariablesValueExist} onClickAdd={(value) => onClickAddContextVariablesValueExist(value, index)} onClickDelete={(cv_index) => onClickDeleteContextVariablesValueExist(index, cv_index)} />
                                                </ErrorBoundary>
                                            </div>
                                        </ErrorBoundary>
                                    }
                                    {
                                        item && item.message_before &&
                                        <ErrorBoundary>
                                            <SelectArrayItem type="object" title={message_before_title} select_placeholder={message_before_placeholder} add_btn_text="add message before" array={item.message_before} options={messages} onClickDelete={(message_before_index) => onClickDeleteMessageBeforeItem(index, message_before_index)} onClickAdd={(value) => onClickAddMessageBeforeItem(value, index)} />
                                        </ErrorBoundary>
                                    }
                                </div>
                            </Panel>
                        );
                    })
                }
            </Collapse>
            <Button type="dashed" className="ori-full-width" onClick={onClickAddResetWorkflows} >Add Reset Workflows</Button>
        </div>
    );
};

ResetWorkflowsForm.propTypes = {
    reset_workflows: PropTypes.array.isRequired,
    workflows: PropTypes.array,
    variables: PropTypes.array,
    actions: PropTypes.array,
    messages: PropTypes.array,
    title: PropTypes.string,
    title_class: PropTypes.string,
    container_class: PropTypes.string,
    card_container_class: PropTypes.string,
    workflow_container: PropTypes.string,
    workflow_title: PropTypes.string,
    workflow_title_class: PropTypes.string,
    workflow_select_class: PropTypes.string,
    workflow_placeholder: PropTypes.string,
    onChangeWorkflow: PropTypes.func,
    node_container: PropTypes.string,
    node_title: PropTypes.string,
    node_title_class: PropTypes.string,
    node_select_class: PropTypes.string,
    node_placeholder: PropTypes.string,
    node_visit_title: PropTypes.string,
    onChangeNode: PropTypes.func,
    onClickAddResetWorkflows: PropTypes.func,
    onChangeNodeVisit: PropTypes.func,
    reset_parameter_title: PropTypes.string,
    onChangeParameterKey: PropTypes.func,
    onChangeParameterValue: PropTypes.func,
    onClickAddResetParameter: PropTypes.func,
    onClickDeleteResetParameterItem: PropTypes.func,
    message_before_title: PropTypes.string,
    message_before_placeholder: PropTypes.string,
    onClickDeleteMessageBeforeItem: PropTypes.func,
    onClickAddMessageBeforeItem: PropTypes.func,
    criteria_title: PropTypes.string,
    onChangeContextVariableKey: PropTypes.func,
    onChangeContextVariableValue: PropTypes.func,
    onClickDeleteContextVariable: PropTypes.func,
    onClickAddContextVariable: PropTypes.func,
    context_variable_value_title: PropTypes.string,
    context_variable_value_placeholder: PropTypes.string,
    onClickAddContextVariablesValueExist: PropTypes.func,
    onClickDeleteContextVariablesValueExist: PropTypes.func,
    current_workflow_title: PropTypes.string,
    current_workflow_placeholder: PropTypes.string,
    onChangeCurrentWorkflow: PropTypes.func,
    onClickDeleteResetWorkflowsItem: PropTypes.func,
};

ResetWorkflowsForm.defaultProps = {
    card_container_class: "ori-tb-mrgn-5",
    message_before_title: "Message Before",
    message_before_placeholder: "select new message before",
    context_variable_value_title: "context variables value exist",
    context_variable_value_placeholder: "select context variables value exist",
    current_workflow_title: "current workflow",
    current_workflow_placeholder: "select current workflow",
};

export default ResetWorkflowsForm;



// WEBPACK FOOTER //
// ./src/components/form/resetworkflowsform/index.js